/**
 * Rapor modelindeki (ReportGenerator/GetReportModel, GetReportVersionPreview) alan anahtarları.
 * Bölüm içerikleri sabit kodlarla, üst bilgiler {{yer tutucu}} adlarıyla gelir.
 */
export const REPORT_FIELD_KEYS = {
    firmName: '{{firmName}}',
    hospitalName: '{{hospitalName}}',
    hospitalOfficialName: '{{hospitalOfficialName}}',
    patientId: '{{patientId}}',
    patientName: '{{patientName}}',
    gender: '{{gender}}',
    patientBirthdate: '{{patientBirthdate}}',
    age: '{{age}}',
    createdDate: '{{createdDate}}',
    accessionNumber: '{{accessionNumber}}',
    studyDate: '{{studyDate}}',
    modality: '{{modality}}',
    requestName: '{{requestName}}',
    complaintPeriod: '{{complaintPeriod}}',
    diagnosis: '{{diagnosis}}',
    medicalHistory: '{{medicalHistory}}',
    patientComplaint: '{{patientComplaint}}',
    physicalExamination: '{{physicalExamination}}',
    clinicalInformation: '{{clinicalInformation}}',
    previousExaminations: '{{previousExaminations}}',
    doctorName: '{{doctorName}}',
    doctorReportName: '{{doctorReportName}}',
    doctorSign: '{{doctorSign}}',
    teknik: 'ECAHUAQD',
    bulgular: 'AZCMSRCT',
    karsilastirma: 'QWDGGXPD',
    sonucVeOneri: 'SUFHFZNM'
};

/** Raporun yazılan bölümleri, raporda göründükleri sırayla. label: i18n anahtarı. */
export const REPORT_SECTIONS = [
    { key: REPORT_FIELD_KEYS.teknik, label: 'Technique' },
    { key: REPORT_FIELD_KEYS.bulgular, label: 'Findings' },
    { key: REPORT_FIELD_KEYS.karsilastirma, label: 'Comparison' },
    { key: REPORT_FIELD_KEYS.sonucVeOneri, label: 'Conclusion and Recommendation' },
];

/** Modeldeki bir alanın değeri; alan yoksa ya da boşsa ''. */
export const reportFieldValue = (reportFields, key) => reportFields?.find(x => x.key === key)?.data || '';
